var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83067",
    "data-name": "Group 83067",
    transform: "translate(-447 -1943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23086",
    "data-name": "Path 23086",
    d: "M5457.964,0a19,19,0,1,1-19,19,19,19,0,0,1,19-19",
    transform: "translate(-4991.965 1943)",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23087",
    "data-name": "Path 23087",
    d: "M5563.151,192.133c0-2.007-.022-4.035,0-6.041l5.339,2.9c-.187.133-5.313,3.139-5.342,3.139m-5.541-9.78a2.519,2.519,0,0,0-2.233,2.084c-.427,2.132-.623,7.775.2,9.84.461,1.163,1.488,1.486,2.694,1.623a123.391,123.391,0,0,0,14.473-.1,2.534,2.534,0,0,0,2.192-2.122c.41-2.161.681-7.752-.187-9.8-.779-1.839-3.019-1.7-4.7-1.776a90.332,90.332,0,0,0-12.432.254",
    transform: "translate(-5099.008 1773.494)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social_youtube.90ce29474074f68d04717ba733254c34.svg";
export { ForwardRef as ReactComponent };